<template>
  <VueLive :code="template" :editor-props="{ lineNumbers: true }" />
</template>
<script>
import { defineComponent } from "vue";
import { VueLive } from "vue-live";

export default defineComponent({
  name: "Vuep",
  components: { VueLive },
  props: {
    template: { type: String, default: "" }
  }
});
</script>
